import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * Common validators shared across all adapter types
 */

// Placeholder for existing credentials (UUID length: 36 characters)
export const CREDENTIAL_PLACEHOLDER = '************************************';

/**
 * Validator for UUID format (e.g., for HEC Token, Tenant ID, Client ID)
 * Used by multiple adapter types (Splunk, Sentinel, etc.)
 * In edit mode, accepts the CREDENTIAL_PLACEHOLDER as valid
 * @param fieldName - The name of the field being validated (for error messages)
 * @param isEditMode - Whether the form is in edit mode
 */
export function uuidValidator(fieldName: string, isEditMode = false): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }
    const value = control.value as string;

    // In edit mode, accept the placeholder as valid (credential unchanged)
    if (isEditMode && value === CREDENTIAL_PLACEHOLDER) {
      return null;
    }

    const uuidRegex = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;
    if (!uuidRegex.test(value)) {
      return { invalidUuid: { value, fieldName } };
    }
    return null;
  };
}

/**
 * Validator for HTTPS URL format
 * Ensures URL starts with https://
 * @param fieldName - The name of the field being validated (for error messages)
 */
export function httpsUrlValidator(fieldName: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }
    const value = control.value as string;
    if (!value.startsWith('https://')) {
      return { invalidHttpsUrl: { value, message: `${fieldName} must start with https://` } };
    }
    return null;
  };
}
